import Vue from 'vue';
import Router from 'vue-router';

import ykHome from '@/page/home/home';
import Transfer from './routes/transfer.route';
import Home from './routes/home.route';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [{
        path: '/',
        component: ykHome
    },
    ...Transfer,
    ...Home]
});



// WEBPACK FOOTER //
// ./src/router/index.js